module.exports = __webpack_public_path__ + "static/img/edit-pencil.691c7ceb.svg";